import { isEmpty, mapKeys, isArray, isString, isBoolean, isInteger } from "lodash";

// Utility function to check if a value should be included in the result
// Returns true for non-empty values, booleans, and integers
const checkForNoneEmpty = value => !isEmpty(value) || value === true || value === false || isInteger(value);

/**
 * Prepares search parameters for request body by cleaning and filtering the input object
 * @param {Object} params - The input parameters object to process
 * @return {Object} - Cleaned object with empty values removed
 */
const prepareSearchReferralsParamsForBody = params => {
  // Early return for empty input
  if (isEmpty(params)) return {};

  // Initialize result object to store cleaned parameters
  const result = {};

  // Create a stack to track objects that need processing
  // Each stack item contains:
  //   - obj: The object to process
  //   - target: Where to store the processed values
  const stack = [{ obj: params, target: result }];

  // Process objects until stack is empty
  while (stack.length > 0) {
    // Get the next object and its target from the stack
    const { obj, target } = stack.pop();

    // Iterate through all properties of the current object
    mapKeys(obj, (value, key) => {
      // Skip empty values that don't meet our criteria
      if (!checkForNoneEmpty(value)) return;

      // Case 1: Handle primitive values (strings, booleans, integers)
      if (isString(value) || isBoolean(value) || isInteger(value)) {
        target[key] = value;

        // eslint-disable-next-line brace-style
      }
      // Case 2: Handle arrays - filter out empty values
      else if (isArray(value)) {
        // Only include arrays that have at least one non-empty value
        if (value.some(checkForNoneEmpty)) {
          target[key] = value.filter(checkForNoneEmpty);
        }

        // eslint-disable-next-line brace-style
      }
      // Case 3: Handle nested objects
      else if (!isEmpty(value)) {
        // Create a new object in the result to hold nested properties
        target[key] = {};
        // Add the nested object to the stack for processing
        stack.push({ obj: value, target: target[key] });
      }
    });
  }

  return result;
};

export default prepareSearchReferralsParamsForBody;
